export default __webpack_public_path__ + "static/media/size_board.b5369693.jpeg";